import { useUserStore } from "@/store/user"

export default defineNuxtPlugin(async (nuxtApp) => {
  if (import.meta.client) {
    const config = useRuntimeConfig()
    const userStore = useUserStore()

    // Dynamic import to avoid SSR issues
    const { default: ActionCableVue } = await import("actioncable-vue")

    const options = {
      debug: process.env.NODE_ENV == "development",
      debugLevel: process.env.NODE_ENV == "development" ? "all" : "error",
      connectionUrl: () => {
        return `${config.public.WS_URL}?token=${userStore.token}`
      },
      connectImmediately: false,
    }

    nuxtApp.vueApp.use(ActionCableVue, options)
  }
})
